import { FC, useState } from 'react'
import React from 'react'
import styled from 'styled-components'

export const Toolbar: FC<{
  buttons: Record<string, string>
  defaultButton?: string | null
  selectStation: (key: string) => void
  lang: 'fr' | 'de'
}> = ({ buttons, defaultButton = 'PUY', selectStation, lang }) => {
  const [activeButton, setActiveButton] = useState<string>(defaultButton || '')
  const handleClick = (e: any) => {
    setActiveButton(e.target.value)
    selectStation(e.target.value)
  }
  return (
    <>
      <ToolbarLabel>
        {lang === 'fr' ? 'Choisissez un lieu' : 'Bitte wählen Sie einen Ort'}
      </ToolbarLabel>
      <Container>
        {Object.entries(buttons).map(([key, name]) => (
          <Button
            value={key}
            key={key}
            onClick={handleClick}
            active={activeButton === key}
          >
            {name.toString()}
          </Button>
        ))}
      </Container>
    </>
  )
}
const ToolbarLabel = styled.p`
  font-size: 0.9em;
  margin-bottom: 0.5rem;
`
const Container = styled.div<{ tenant?: string }>`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  column-gap: 1ch;
  row-gap: 1ch;
`
const Button = styled.button<{ active?: boolean }>`
  // TODO: ajouter une animation
  display: inline-block;
  border: none;
  border-radius: 5px;
  padding: 0.5rem 1rem;
  background: ${(props) =>
    props.active ? 'var(--brandblue-bright-1)' : 'var(--brandblue-main)'};

  color: #e9e9e9;
  font-family: var(--font-sans-serif);
  font-size: 1.8rem;
  font-weight: 500;

  cursor: pointer;
  &:hover {
    border-color: 3px solid yellow;
    background: black;
  }
`
